export const GetDateLong = (str) => {
    try {
        const date = new Date(str);
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
        const date_format = date.toLocaleDateString('fr', options);
        return date_format;
    } catch (e) {
        console.log(e);
    }
}

export const GetDateShort = (str) => {
    try {
        const date = new Date(str);
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
        const brut = date.toLocaleDateString('fr', options).split('/');
        const date_format = `${brut[2]}-${brut[1]}-${brut[0]}`;
        return date_format;
    } catch (e) {
        console.log(e);
    }
}

export const GetDateShortFR = (str) => {
    try {
        const date = new Date(str);
        const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
        const brut = date.toLocaleDateString('fr', options).split('/');
        const date_format = `${brut[0]}-${brut[1]}-${brut[2]}`;
        return date_format;
    } catch (e) {
        console.log(e);
        return '-';
    }
}

export const GetDateLongFR = (str) => {
    try {
        const date = new Date(str);
        const options = { year: 'numeric', month: 'long', day: 'numeric' }
        const date_format = date.toLocaleDateString('fr', options).split('T')[0];
        return date_format;
    } catch (e) {
        console.log(e);
        return '-';
    }
}

export const GetYearMonthDay = (str) => {
    try {
        let date = str.split('T')[0];
        return date;
    } catch(e) {
        console.log(e);
        return '-';
    }
}

export const GetYear = (str) => {
    try {
        let date = str.split('-')[0];
        return date;
    } catch(e) {
        console.log(e);
        return '-';
    }
}

export const GetDayMonthYear = (str) => {
    try {
        let brut = str.split('T')[0];
        let date = brut.split('-');
        return `${date[2]}-${date[1]}-${date[0]}`;
    } catch(e) {
        console.log(e);
        return '-';
    }
}